export default __webpack_public_path__ + "static/media/spark_50.82bec0fc.png";